import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/services/notification.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { TasksService } from 'src/services/tasks.service';
import { SprintService } from '../../services/sprintSheet.service';
declare var $;

@Component({
  selector: 'app-sprint-detail',
  templateUrl: './sprint-detail.component.html',
  styleUrls: ['./sprint-detail.component.css']
})
export class SprintdetailComponent implements OnInit, OnDestroy {
  public loginUser: any = "";
  public applicationId: number = null;
  public sprintDetail: any[] = [];
  public filteredSprintDetail: any[] = [];
  public sprintCommentList: any = [];
  public riskList: any = [];
  public boxToggle: boolean = false;
  public isTaskAdded: boolean = false;
  public taskId: number = 0;
  public riskId: number = 0;
  public isRiskEdit: boolean = false;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  public startDate: Date;
  public todayDate: Date;
  public endDate: Date;

  tasksCompleted: number;
  totalTasks: number;
  workHoursDone: number;
  totalHours: number;
  totalWorkingHours: number;
  remainingHours: number;
  totalLeaveHours: number;
  totalPublicHolidayHours: number;
  totalNoWorkBatchHours: number;
  selectedItemId: number | null = 0;
  
  public title: any = '';
  public riskTitle: any = '';
  public riskDescription: any = '';
  public riskSeverity: string = 'Medium';
  public riskStatus: string = 'Open';

  // No Work Batch
  public nwbList: any[] = [];
  public nwbDate: string = '';
  public nwbHours: number = 8;
  public nwbReason: string = '';
  
  public pageNumber = 1;
  public pageSize = 25;
  public sortOrder = "desc";
  public sortBy = "DateAdded";
  public totalSprintCount: number = 0;
  public year: any = moment().format('YYYY');
  
  progressStyle: any = {};
  dropdownItems: any[] = [];
  isTodayEndSame: boolean = false;
  istoday: boolean = false;
  isStartDay: boolean = false;
  isTableInitialized: boolean = false;
  
  uniqueNames: string[] = [];
  selectedName: string = '';
  uniqueProjects: string[] = [];
  selectedProject: string = '';
  
  severityOptions: string[] = ['High', 'Medium', 'Low'];
  statusOptions: string[] = ['Open', 'In Progress', 'Resolved', 'Closed'];

  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private noti: NotificationService,
    private router: Router,
    private tasksService: TasksService,
    private sprintService: SprintService,
  ) { }

  ngOnInit() {
    this.applicationId = this.route.snapshot.queryParams.id;
    this.selectedItemId = this.route.snapshot.queryParams.id;
    this.loginUser = JSON.parse(localStorage.getItem('user'));
    
    // Subscribe to route params to handle navigation changes
    this.route.queryParams.subscribe(params => {
      if (params.id && params.id != this.applicationId) {
        this.applicationId = params.id;
        this.selectedItemId = params.id;
        this.loadData();
      }
    });
    
    this.loadDropdownData(this.applicationId);
    this.loadData();
    this.resetRiskForm();
  }

  loadData() {
    this.getBackup();
    this.getAllSprintComment();
    this.getAllRisks();
    this.getAllNoWorkBatch();
  }

  getBackup() {
    this.sprintDetail = [];
    this.filteredSprintDetail = [];

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      order: [[2, 'desc']],
      dom: 'rt',
      destroy: true,
      autoWidth: false
    };

    this.tasksService.getSprintSheetDetailById(this.applicationId).subscribe(response => {
      if (response.status === "ok") {
        $(".custom-loader").css("display", "none");
        this.sprintDetail = response.data.result || [];

        if (this.sprintDetail.length > 0) {
          this.appService.headerTitle.emit({ data: this.sprintDetail[0].sprintName });
          this.startDate = new Date(this.sprintDetail[0].startDate);
          this.endDate = new Date(this.sprintDetail[0].endDate);
          this.todayDate = new Date();

          let allProjectNames: string[] = [];
          this.sprintDetail.forEach((item: any) => {
            if (Array.isArray(item.projectNames)) {
              allProjectNames.push(...item.projectNames);
            }
          });
          allProjectNames = allProjectNames.filter(name => name && name.trim() !== "");
          this.uniqueProjects = Array.from(new Set(allProjectNames));

          this.uniqueNames = Array.from(
            new Set(this.sprintDetail.map(x => x.userName).filter(name => !!name))
          );

          this.filteredSprintDetail = [...this.sprintDetail];
          this.calculateCombinedTotals(this.filteredSprintDetail);
          this.calculateProgress();
        }

        if (this.isTableInitialized) {
          this.rerender();
        } else {
          this.dtTrigger.next();
          this.isTableInitialized = true;
        }
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  filterByProject() {
    this.tasksService.getSprintSheetDetailByselectedProject(
      this.selectedItemId, 
      this.selectedProject, 
      this.selectedName
    ).subscribe(response => {
      if (response.status === "ok") {
        $(".custom-loader").css("display", "none");
        this.sprintDetail = response.data.result || [];
        this.filteredSprintDetail = [...this.sprintDetail];
        this.calculateCombinedTotals(this.filteredSprintDetail);
        this.calculateProgress();
        this.rerender();
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  refreshData() {
    this.getBackup();
    this.selectedProject = '';
    this.selectedName = '';
  }

  calculateCombinedTotals(list: any[]) {
    if (!Array.isArray(list) || list.length === 0) {
      this.tasksCompleted = this.totalTasks = this.workHoursDone = this.totalHours = 0;
      this.totalLeaveHours = this.totalPublicHolidayHours = this.totalNoWorkBatchHours = 0;
      return;
    }

    this.workHoursDone = list.reduce((sum, x) => sum + (x.userActualHours || 0), 0);
    this.totalHours = list.reduce((sum, x) => sum + (x.userEstimatedHours || 0), 0);
    this.totalWorkingHours = list.reduce((sum, x) => sum + (x.totalWorkingHours || 0), 0);
    this.remainingHours = list.reduce((sum, x) => sum + (x.remainingHours || 0), 0);
    this.totalLeaveHours = list.reduce((sum, x) => sum + (x.leaveHours || 0), 0);
    // Public holiday hours are the same for all users — take the value from the first row
    this.totalPublicHolidayHours = list.length > 0 ? (list[0].publicHolidayHours || 0) : 0;
    this.totalNoWorkBatchHours = list.reduce((sum, x) => sum + (x.noWorkBatchHours || 0), 0);
    
    const uniqueTasksMap = new Map<number | string, any>();
    list.forEach(item => {
      const key = item.taskId ? item.taskId : item.taskName;
      if (!uniqueTasksMap.has(key)) {
        uniqueTasksMap.set(key, item);
      }
    });
    
    const uniqueTasks = Array.from(uniqueTasksMap.values());
    this.tasksCompleted = uniqueTasks.reduce((sum, x) => sum + (x.completeTasks || 0), 0);
    this.totalTasks = uniqueTasks.reduce((sum, x) => sum + (x.sprintTotalTasks || 0), 0);
  }

  calculateProgress(): void {
    this.progressStyle = {
      todayPercent: this.getTimelineProgress(),
      taskWidth: this.totalTasks > 0 ? (this.tasksCompleted / this.totalTasks) * 100 : 0,
      hourWidth: this.totalWorkingHours > 0 ? (this.workHoursDone / this.totalWorkingHours) * 100 : 0,
      estimateWidth: this.totalWorkingHours > 0 ? (this.totalHours / this.totalWorkingHours) * 100 : 0
    };

    const today = new Date(this.todayDate);
    const endDate = new Date(this.endDate);
    const startDate = new Date(this.startDate);
    
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);

    this.isTodayEndSame = endDate.getTime() <= today.getTime();
    this.istoday = endDate.getTime() === today.getTime();
    this.isStartDay = startDate.getTime() === today.getTime();
  }

  getTimelineProgress(): number {
    const oneDay = 24 * 60 * 60 * 1000;
    const totalDays = Math.round((this.endDate.getTime() - this.startDate.getTime()) / oneDay);
    const daysPassed = Math.round((this.todayDate.getTime() - this.startDate.getTime()) / oneDay);
    return totalDays > 0 ? (daysPassed / totalDays) * 100 : 0;
  }

  getAllSprintComment() {
    this.sprintService.getSprintCommentList(
      this.pageNumber, 
      this.pageSize, 
      this.sortBy, 
      this.sortOrder
    ).subscribe(response => {
      if (response != null && response.status == "ok") {
        const allComments = response.data.value;
        const appId = Number(this.applicationId);
        
        this.sprintCommentList = allComments.filter(
          (comment: any) => Number(comment.sprintId) === appId
        );

        $(".custom-loader").css("display", "none");
        this.totalSprintCount = this.sprintCommentList.length > 0 
          ? this.sprintCommentList[0].totalRecords 
          : 0;
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  getAllRisks() {
    this.tasksService.getSprintRisksBySprint(this.applicationId).subscribe(response => {
      if (response.status === "ok") {
        const allRisks = response.data || [];
        const accessLevel = this.loginUser ? this.loginUser.accessLevel : '';
        if (accessLevel === 'admin' || accessLevel === 'super_admin') {
          this.riskList = allRisks;
        } else {
          this.riskList = allRisks.filter((risk: any) => risk.userId === this.loginUser.userId);
        }
      }
    }, error => {
      if (error.status == 401) { }
    });
  }

  openTask(taskId) {
    if (!taskId) return;
    this.router.navigate(['/tasks/list'], { queryParams: { openTaskId: taskId } });
  }

  editRisk(risk) {
    this.riskId = risk.id;
    this.riskTitle = risk.title;
    this.riskDescription = risk.description || '';
    this.riskSeverity = risk.severity;
    this.riskStatus = risk.status;
    this.isRiskEdit = true;
  }

  addTask() {
    $(".btn-submit").prop('disabled', true);
    
    if (!this.validateComment()) {
      $(".btn-submit").prop('disabled', false);
      return;
    }

    const taskObj = {
      Title: this.title.trim(),
      SprintId: this.applicationId,
      UserID: this.loginUser.userId,
      Adddate: new Date(),
    };

    this.tasksService.addSprintComment(taskObj).subscribe(res => {
      if (res.status == "ok") {
        this.taskId = res.data.id;
        this.noti.notification("Success", "Comment Added Successfully", "success");
        this.getAllSprintComment();
        this.showTaskDetails(res.data);
        this.isTaskAdded = true;
      }
      $(".btn-submit").prop('disabled', false);
    }, error => {
      if (error.status == 401) { }
      $(".btn-submit").prop('disabled', false);
    });
  }

  updateTask() {
    $(".btn-submit").prop('disabled', true);
    
    if (!this.validateComment()) {
      $(".btn-submit").prop('disabled', false);
      return;
    }

    const taskObj = {
      id: this.taskId,
      title: this.title.trim(),
      SprintId: this.applicationId,
      UserID: this.loginUser.userId,
      Adddate: new Date(),
    };

    this.tasksService.updateSprintComment(taskObj).subscribe(res => {
      if (res.status == "ok") {
        this.noti.notification("Success", "Comment Updated Successfully", "success");
        this.getAllSprintComment();
        this.showTaskDetails(res.data);
        this.isTaskAdded = true;
      }
      $(".btn-submit").prop('disabled', false);
    }, error => {
      if (error.status == 401) { }
      $(".btn-submit").prop('disabled', false);
    });
  }

  showTaskDetails(data) {
    this.addTaskToggle();
    $('.slider-log').addClass('close-b');
    $(".slider-log-wrapper").height(0);
    $("html, body").animate({ scrollTop: 0 }, "slow");
    
    this.taskId = data.id;
    this.title = data.title;
    this.isTaskAdded = true;
    $(".btn-submit").prop('disabled', false);
  }

  addRisk() {
    $(".btn-submit-risk").prop('disabled', true);
    
    if (!this.validateRisk()) {
      $(".btn-submit-risk").prop('disabled', false);
      return;
    }

    const riskObj = {
      Title: this.riskTitle.trim(),
      Description: this.riskDescription.trim(),
      Severity: this.riskSeverity,
      Status: this.riskStatus,
      SprintId: this.applicationId,
      UserId: this.loginUser.userId,
      DateAdded: new Date(),
    };

    this.tasksService.addSprintRisk(riskObj).subscribe(res => {
      if (res.status == "ok") {
        this.riskId = res.data.id;
        this.noti.notification("Success", "Risk Added Successfully", "success");
        this.getAllRisks();
        this.resetRiskForm();
      }
      $(".btn-submit-risk").prop('disabled', false);
    }, error => {
      if (error.status == 401) { }
      $(".btn-submit-risk").prop('disabled', false);
    });
  }

  updateRisk() {
    $(".btn-submit-risk").prop('disabled', true);
    
    if (!this.validateRisk()) {
      $(".btn-submit-risk").prop('disabled', false);
      return;
    }

    const riskObj = {
      Id: this.riskId,
      Title: this.riskTitle.trim(),
      Description: this.riskDescription.trim(),
      Severity: this.riskSeverity,
      Status: this.riskStatus,
      SprintId: this.applicationId,
      UserId: this.loginUser.userId,
      DateUpdated: new Date(),
    };

    this.tasksService.updateSprintRisk(riskObj).subscribe(res => {
      if (res.status == "ok") {
        this.noti.notification("Success", "Risk Updated Successfully", "success");
        this.getAllRisks();
        this.resetRiskForm();
      }
      $(".btn-submit-risk").prop('disabled', false);
    }, error => {
      if (error.status == 401) { }
      $(".btn-submit-risk").prop('disabled', false);
    });
  }

  showRiskDetails(risk) {
    this.riskId = risk.id;
    this.riskTitle = risk.title;
    this.riskDescription = risk.description;
    this.riskSeverity = risk.severity;
    this.riskStatus = risk.status;
  }

  validateComment() {
    if (this.title.length < 4) {
      this.noti.notification("Error", "Please enter at least 5 characters", "danger");
      return false;
    }
    return true;
  }

  validateRisk() {
    if (this.riskTitle.length < 4) {
      this.noti.notification("Error", "Please enter risk title (at least 5 characters)", "danger");
      return false;
    }
    if (this.riskDescription.length < 10) {
      this.noti.notification("Error", "Please enter risk description (at least 10 characters)", "danger");
      return false;
    }
    return true;
  }

  resetCommentForm() {
    this.title = '';
    this.taskId = 0;
    this.isTaskAdded = false;
  }

  resetRiskForm() {
    this.riskTitle = '';
    this.riskDescription = '';
    this.riskSeverity = 'Medium';
    this.riskStatus = 'Open';
    this.riskId = 0;
    this.isRiskEdit = false;
  }

  addTaskToggle() {
    if (!this.boxToggle) {
      this.boxToggle = true;
      this.isTaskAdded = false;
    } else {
      this.isTaskAdded = false;
      this.taskId = 0;
      $('.slider-log').addClass('close-b');
      $(".slider-log-wrapper").height(0);
    }
  }

  closeTaskToggle() {
    $('.slider-log').addClass('close-b');
    $(".slider-log-wrapper").height(0);
    this.resetCommentForm();
    this.boxToggle = false;
  }

  loadDropdownData(selectedSprintId?: number) {
    this.tasksService.getSprintSheet().subscribe({
      next: (res: any) => {
        if (res.status === "ok" && res.data) {
          this.dropdownItems = res.data;

          if (selectedSprintId) {
            this.selectedItemId = selectedSprintId;
          } else if (this.dropdownItems.length > 0) {
            const lastItem = this.dropdownItems[this.dropdownItems.length - 1];
            this.selectedItemId = lastItem.id;
          } else {
            this.selectedItemId = 0;
          }
        } else {
          this.dropdownItems = [];
          this.selectedItemId = 0;
        }
      },
      error: (err) => {
        console.error("Error loading sprint list:", err);
        this.dropdownItems = [];
        this.selectedItemId = 0;
      }
    });
  }

  onDropdownChange(event: any) {
    let selectedValue: any = null;

    if (event && event.target && event.target.value) {
      selectedValue = event.target.value;
    } else {
      selectedValue = this.selectedItemId;
    }

    this.selectedItemId = +selectedValue;

    // Reset filters when sprint changes
    this.selectedProject = '';
    this.selectedName = '';
    this.uniqueNames = [];
    this.uniqueProjects = [];

    // Navigate without reload
    this.router.navigate(['/sprint-detail'], {
      queryParams: { id: this.selectedItemId },
      queryParamsHandling: 'merge'
    });
  }

  rerender(): void {
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    }
  }

  getAllNoWorkBatch() {
    this.tasksService.getNoWorkBatch(this.applicationId).subscribe(response => {
      if (response.status === 'ok') {
        this.nwbList = response.data || [];
      }
    }, error => { });
  }

  addNoWorkBatch() {
    if (!this.nwbDate) {
      this.noti.notification('Error', 'Please select a date', 'danger');
      return;
    }
    if (!this.nwbHours || this.nwbHours <= 0) {
      this.noti.notification('Error', 'Please enter valid hours', 'danger');
      return;
    }

    const entry = {
      UserId: this.loginUser.userId,
      SprintId: this.applicationId,
      Date: this.nwbDate,
      Hours: this.nwbHours,
      Reason: this.nwbReason
    };

    this.tasksService.addNoWorkBatch(entry).subscribe(res => {
      if (res.status === 'ok') {
        this.noti.notification('Success', 'No Work Batch added', 'success');
        this.nwbDate = '';
        this.nwbHours = 8;
        this.nwbReason = '';
        this.getAllNoWorkBatch();
        this.getBackup();
      }
    }, error => { });
  }

  deleteNoWorkBatch(id) {
    this.tasksService.deleteNoWorkBatch(id).subscribe(res => {
      if (res.status === 'ok') {
        this.noti.notification('Success', 'Deleted', 'success');
        this.getAllNoWorkBatch();
        this.getBackup();
      }
    }, error => { });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}